// extracted by mini-css-extract-plugin
export default {"-large":"ZS8rYVfTvBbpZad1wKR8","HTMLSnippetSpacing":"jsJPKVsnYENX_otBS8V_","customModalHeight":"Q1P62wgQ2gNkeePymeDS","customDropDownHeight":"aBy6sMX33CSrvad0XTHd"};